if (!customElements.get("share-button")) {
  customElements.define(
    "share-button",
    class ShareButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("button");

        if (this.button) {
          this.button.addEventListener("click", this.handleShare.bind(this));
        }
      }

      updateUrl(url) {
        if (this.button) {
          this.button.dataset.shareUrl = url;
        }
      }

      async handleShare() {
        const url = this.button.dataset.shareUrl || window.location.href;
        const title = this.button.dataset.shareTitle || document.title;

        if (navigator.share) {
          try {
            await navigator.share({ title: title, url: url });
          } catch (error) {
            console.error("Error sharing:", error);
          }
        } else {
          navigator.clipboard.writeText(url).then(() => {
            const textElement = this.button.querySelector("span");
            if (!textElement) return;

            const originalText = textElement.textContent;
            textElement.textContent = "Link copied!";

            setTimeout(() => {
              textElement.textContent = originalText;
            }, 2500);
          });
        }
      }
    },
  );
}
